import React from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

import Popup from '../Popup/index';
import CameraOptions from '../CameraOptions/index';
import GeneralOptions from '../GeneralOptions/index';
import SoundOptions from '../SoundOptions/index';

import UserSettings from './UserSettings';

import Registry from '../../../registry/index';

class SettingsPopup extends Popup {
    constructor(props) {
        super(props);

        this.showOverlay = true;
        this.afterClosePositionReset = false;
    }

    render() {
        let lang = Registry.get('locale');
        let {currentUser, currentRoom} = this.props;
        let className = 'popup popup-settings ' + this.state.visibility;

        return (
            <div className={className} ref={(ref) => this._ref = ref}>
                <div className="top">
                    <p>{this.props.title ? this.props.title : lang.settings}</p>
                    <div className="close" onClick={() => this.close()}/>
                </div>
                <div className="content">
                    {this.props.content}
                </div>
            </div>
        )
    }
}

SettingsPopup.generateKey = function(props) { return 'settings-popup' };
SettingsPopup.mount = function(props, onMount) { return Popup.mount(SettingsPopup, props, onMount) };
SettingsPopup.open = function(props) {
    var id = SettingsPopup.generateKey(props);

    //if (!Popup.popups[id]) {
        SettingsPopup.mount(props, () => Popup.popups[id].open());
    //} else {
    //    Popup.popups[id].open()
    //}
};
SettingsPopup.close = function(props) {
    var id = SettingsPopup.generateKey(props);

    if (Popup.popups[id]) {
        Popup.popups[id].close()
    }
};

export default SettingsPopup;


// WEBPACK FOOTER //
// ./src/components/bobtv-neo/SettingsPopup/index.js